import { useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { makeApi } from "@/lib/api";

const LABEL = { Ratecon: "ratecon", POD: "POD/BOL" };

export const DeleteDocDialog = ({ doc, onClose, onDeleted, trashNote = "An admin can restore it from Trash within 30 days." }) => {
  const { getToken } = useAuth();
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await makeApi(getToken).delete(`/documents/${doc.id}`);
      toast.success(`${doc.original_filename} moved to Trash`);
      onClose();
      onDeleted();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not delete");
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmDialog
      open={!!doc}
      busy={busy}
      title={`Delete this ${LABEL[doc?.type] || "document"}?`}
      confirmLabel="Move to Trash"
      testId="delete-doc-dialog"
      onCancel={onClose}
      onConfirm={confirm}
      description={
        <>
          <p className="font-medium text-slate-800 break-all">{doc?.original_filename}</p>
          <p>{trashNote}</p>
        </>
      }
    />
  );
};
